import { computed, toValue } from "vue";
const useAriaInvalid = (ariaInvalid, state) => computed(() => {
  const resolvedAriaInvalid = toValue(ariaInvalid);
  const resolvedState = toValue(state);
  const resolvedAriaInvalidValue = resolvedAriaInvalid === true ? "true" : typeof resolvedAriaInvalid === "string" ? resolvedAriaInvalid : resolvedState === false ? "true" : resolvedAriaInvalid === false ? "false" : void 0;
  return resolvedAriaInvalidValue;
});
export {
  useAriaInvalid as u
};
//# sourceMappingURL=useAriaInvalid-BTUbGj3Y.mjs.map
